import { GeneralModel } from "./general.model";
import { District } from "./district.model";
import { Ward } from "./ward.model";

export class Hub extends GeneralModel {
    email:string;
    phoneNumber:string;
    address:string;
    addressPrint:string;
    fax:string;
    lat:number;
    lng:number;
    districtId:number;
    wardId:number;
    centerHubId:number;
    poHubId:number;
    district:District;
    ward:Ward;
    centerHub:Hub;
    poHub:Hub;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/hub.model.ts